import { getHeaderName } from 'src/components/collapsible-table/table-column-prep';
import { ColumnDef, Row } from '@tanstack/table-core';
import { ChangeEvent, useState } from 'react';
import { useAppDispatch } from 'src/hooks';
import { getColumnsForInputFieldFormat } from '../../../../common/features/table/columns-prep';
import { columnHelper } from '../../../../common/features/table/components/output-column-prep';
import {
  Header,
  InputType,
  TableComponent
} from '../../../../pricing-simulator/types/generic-table.model';
import BulkDuplicateSkuCheckbox from './duplicate-skus-checkbox';
import { setDuplicateSkuCount } from '../../../store/innovation-slice';

type TableRowData = {
  [key: string]: any;
};

interface DuplicateCountInputProps {
  row: Row<TableRowData>;
  section: string;
}

const DuplicateCountInput = ({ row, section }: DuplicateCountInputProps) => {
  const [duplicateCount, setDuplicateCount] = useState(1);
  const appDispatch = useAppDispatch();

  const setNumberOfDuplicates = (event: ChangeEvent<HTMLInputElement>) => {
    const countValue = Number(event.target.value);
    if (countValue <= 5 && countValue >= 1) {
      setDuplicateCount(countValue);

      appDispatch(
        setDuplicateSkuCount({
          checked: row.getIsSelected(),
          skuName: row.original.sku as string,
          no_of_duplicates: countValue,
          section
        })
      );
    }
  };

  if (!row.getIsSelected()) {
    return null;
  }

  return (
    <input
      value={duplicateCount}
      onChange={setNumberOfDuplicates}
      className='duplicate-count-input-box'
      type='number'
      min={1}
      max={5}
      placeholder=''
    />
     // <BulkDuplicateSkuCheckbox
    //   row={row}
    //   columnMetadata={columnData}
    //   section={section}
    // />
  );
};

export const getHeaderForBulkDuplicateTable = (
  columnData: Header,
  section: string
) => {
  const subHeader: ColumnDef<TableRowData> = {
    id:
      columnData.parent.parent_field !== ''
        ? columnData.parent.parent_field
        : columnData.parent.order.toString(),
    meta: {
      className: 'last sticky-first-col'
    },
    // eslint-disable-next-line react/no-unescaped-entities
    header: (props) =>
      columnData.children.length > 1 ? (
        <div>
          {' '}
          {columnData.parent.alias} {getHeaderName(columnData)}
        </div>
      ) : null,
    cell: ({ row }) => (
      <BulkDuplicateSkuCheckbox
        row={row}
        columnMetadata={columnData}
        section={section}
      />
    )
  };
  return subHeader;
};

export const getTextColumnForBulkDuplicateTable = (
  columnData: Header,
  section: string
) => {
  const subHeader: ColumnDef<TableRowData> = {
    id:
      columnData.parent.parent_field !== ''
        ? columnData.parent.parent_field
        : columnData.parent.order.toString(),

    // eslint-disable-next-line react/no-unescaped-entities
    header: (props) =>
      columnData.children.length > 1 ? (
        <div>
          {' '}
          {columnData.parent.alias} {getHeaderName(columnData)}
        </div>
      ) : null,
    cell: ({ row }) => <DuplicateCountInput row={row} section={section} />
   
  };
  return subHeader;
};

export default function BulkDuplicateSku(
  columnMetaData: Header[],
  section: string
) {
  return columnMetaData.map((columnData: Header, index: number) => {
    const subHeaders = [];
    if (columnData.parent.field_format === InputType.CHECKBOX) {
      subHeaders.push(getHeaderForBulkDuplicateTable(columnData, section));
    } else if (
      columnData.parent.field_format === InputType.NUMBER &&
      columnData.parent.alias === 'No of Duplicates'
    ) {
      subHeaders.push(getTextColumnForBulkDuplicateTable(columnData, section));
    } else {
      subHeaders.push(
        getColumnsForInputFieldFormat(
          columnData,
          [],
          TableComponent.INNOVATION,
          index,
          false,
          []
        )
      );
    }

    const columnDef = columnHelper.group({
      id: columnData.parent.parent_field
        ? columnData.parent.parent_field
        : index.toString(),
      header: (props) => <span>{columnData.parent.alias}</span>,
      columns: subHeaders
    });
    return columnDef;
  });
}